import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/aransas-pass")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Aransas Pass, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Aransas Pass & San Patricio County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Aransas Pass, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Aransas Pass and San Patricio County.",
      keywords: "awnings Aransas Pass, awning company Aransas Pass, custom awnings Aransas Pass, sail shades Aransas Pass, patio covers Aransas Pass, pergola covers Aransas Pass, metal awnings Aransas Pass, canvas awnings Aransas Pass, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Aransas Pass", "San Patricio County"),
  }),
  component: () => <CityHomePage city="Aransas Pass" region="San Patricio County" />,
});
